// 50,000 records is around 5mb. We are trying to make sure we don't pull too much from the lambda at once
export const defaultDealerCodesPageSize = 50000;
export interface dealerCodeDataResponse {
  dealerCodeData: dealerCodeData[];
  currentPage: number;
  totalPages: number;
  totalElements: number;
}
export interface dealerCodeData {
  id: string;
  accountId: string;
  dealerCode: string;
}
interface Audit {
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
}
export interface CC9DataPair {
  serviceAccountId: string;
  dealerCode: string;
}

export interface dealerCodeDataIncoming {
  id: string;
  accountId: string;
  dealerCode: string;
  dealerCodeType: string;
  userId: string;
  actingAsUserId: string;
  audit: Audit;
}
interface Audit {
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
}
